import { constants } from 'mage-deps/@klarna/bubble-ui'

export const stepLengthHorizontal = 200
export const stepLengthVertical = 25
export const lineWidth = 5
export const stepIconSize = 50
export const fillColor = '#DAEEBC'
export const emptyColor = constants.Colors.GRAY
